<template>
  <div
    v-if="labels.length"
    :class="b('', { isClickable })"
  >
    <div
      v-for="(label, index) in labels"
      :key="`label-${index}`"
      :style="getStyles(label)"
      :class="b('label', { color: predefinedColorName(label) })"
      @click="onLabelClick(label)"
    >
      <!-- eslint-disable vue/no-v-html -->
      <span
        v-if="allowHtml"
        v-html="label.label"
      ></span>
      <template v-else>
        {{ label.label }}
      </template>
    </div>
  </div>
</template>

<script>
  /**
   * This page represents the badge labels.
   */
  export default {
    name: 'e-badge-labels',

    // components: {},
    // mixins: [],

    props: {
      /**
       * Sets the optional list of labels.
       */
      labels: {
        type: Array,
        default: () => [],
      },

      /**
       * Define if the labels are clickable.
       */
      isClickable: {
        type: Boolean,
        default: true,
      },

      /**
       * Define if the labels should be printed with html.
       */
      allowHtml: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['labelClicked'],
    data() {
      return {
        predefinedColors: ['white', 'grey', 'blue', 'green', 'red', 'orange', 'yellow'],
      };
    },

    // computed: {},

    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    methods: {
      /**
       * Click handler.
       *
       * @param {Object} label - The clicked label.
       */
      onLabelClick(label) {
        if (this.isClickable) {
          this.$emit('labelClicked', label);
        }
      },

      /**
       * Returns a list of styles.
       *
       * @param {Object} label - The clicked label.
       *
       * @returns {Object}
       */
      getStyles(label) {
        const styles = {};

        if (!this.predefinedColors.includes(label.backgroundColor)) {
          styles.backgroundColor = label.backgroundColor;
        }

        return styles;
      },

      /**
       * Returns a list of styles.
       *
       * @param {Object} label - The clicked label.
       *
       * @returns {String|null}
       */
      predefinedColorName(label) {
        if (this.predefinedColors.includes(label.backgroundColor)) {
          return label.backgroundColor;
        }

        return null;
      },
    },
    // render() {},
  };
</script>

<style lang="scss">
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';

  .e-badge-labels {
    $this: &;
    $text-color-light: variables.$color-grayscale--1000;
    $text-color-dark: variables.$color-primary--1;
    $text-color-darker: variables.$color-grayscale--50;

    display: flex;
    gap: functions.rem(variables.$spacing--5);
    flex-wrap: wrap;

    &--is-clickable {
      #{$this}__label {
        cursor: pointer;
      }
    }

    &__label {
      @include mixins.font(variables.$font-size--14);

      display: inline-flex;
      align-items: center;
      height: functions.rem(24px);
      padding: functions.rem(0 variables.$spacing--15);
      border-radius: functions.rem(12px);
      background-color: variables.$color-primary--1;
      cursor: default;
      color: $text-color-light;
      line-height: 1;

      &--color-grey {
        background-color: variables.$color-grey;
        color: $text-color-dark;
      }

      &--color-white {
        background-color: variables.$color-white;
        color: $text-color-dark;
      }

      &--color-blue {
        background-color: variables.$color-blue;
        color: $text-color-light;
      }

      &--color-green {
        background-color: variables.$color-green;
        color: $text-color-light;
      }

      &--color-red {
        background-color: variables.$color-red;
        color: $text-color-light;
      }

      &--color-orange {
        background-color: variables.$color-orange;
        color: $text-color-light;
      }

      &--color-yellow {
        background-color: variables.$color-yellow;
        color: $text-color-darker;
      }
    }
  }
</style>
